import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'

const FlexGridVariants = cva(
  cn('grid grid-flow-row xl:grid-flow-col auto-cols-fr gap-8'),
  {
    variants: {
      size: {
        default: '',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

interface FlexGridProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof FlexGridVariants> {
  asChild?: boolean
}

const FlexGrid = React.forwardRef<HTMLDivElement, FlexGridProps>(
  ({ className, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'div'
    return (
      <Comp
        className={cn(FlexGridVariants({ size, className }))}
        ref={ref}
        {...props}
      />
    )
  },
)
FlexGrid.displayName = 'FlexGrid'

export { FlexGrid, FlexGridVariants }
